import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineStart_DEFAULT_getInstancexcjy3fsqr6w6 as CoroutineStart_DEFAULT_getInstance } from './CoroutineStart.mjs';
import {
  newCoroutineContext2tdpc8c02iv5t as newCoroutineContext,
  newCoroutineContext1x74axajiiptk as newCoroutineContext_0,
  UndispatchedCoroutine1g5upie8aljdz as UndispatchedCoroutine,
} from './CoroutineContext.mjs';
import {
  ensureActive2yo7199srjlgl as ensureActive,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { ScopeCoroutine2c07fgm3ekmnx as ScopeCoroutine } from './internal/Scopes.mjs';
import { startUndispatchedOrReturn1od7ryhr362dr as startUndispatchedOrReturn } from './intrinsics/Undispatched.mjs';
import { Key_instancesrycfl6s632h as Key_instance } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  startCoroutineCancellable3v5el961z6rj8 as startCoroutineCancellable,
  startCoroutineCancellable1tb4wrxetke45 as startCoroutineCancellable_0,
} from './intrinsics/Cancellable.mjs';
import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from './AbstractCoroutine.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from './CoroutineExceptionHandler.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  createCoroutineUninterceptedGeneratorVersion2gduom218i9ay as createCoroutineUninterceptedGeneratorVersion,
  intercepted2ogpsikxxj4u0 as intercepted,
} from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { atomic$int$11d5swdyn6j0pu as atomic$int$1 } from '../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  recoverResult92pymwoef8np as recoverResult,
  CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally,
} from './CompletionState.mjs';
import { resumeCancellableWith2mw849xp548hg as resumeCancellableWith } from './internal/DispatchedContinuation.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { unboxStateze7t12boxn2m as unboxState } from './JobSupport.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function launch(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.ux() ? new (LazyStandaloneCoroutine())(newContext, block) : new (StandaloneCoroutine())(newContext, true);
  coroutine.gw(start, coroutine, block);
  return coroutine;
}
function async(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.ux() ? new (LazyDeferredCoroutine())(newContext, block) : new (DeferredCoroutine())(newContext, true);
  coroutine.gw(start, coroutine, block);
  return coroutine;
}
function *withContext(context, block, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var tmp0 = $completion;
    var tmp$ret$1;
    $l$block_0: {
      var oldContext = tmp0.mc();
      var newContext = newCoroutineContext_0(oldContext, context);
      ensureActive(newContext);
      if (newContext === oldContext) {
        var coroutine = new (ScopeCoroutine())(newContext, tmp0);
        tmp$ret$1 = startUndispatchedOrReturn(coroutine, coroutine, block);
        break $l$block_0;
      }
      if (equals(newContext.yc(Key_instance), oldContext.yc(Key_instance))) {
        var coroutine_0 = new (UndispatchedCoroutine())(newContext, tmp0);
        // Inline function 'kotlinx.coroutines.withCoroutineContext' call
        coroutine_0.rv_1;
        tmp$ret$1 = startUndispatchedOrReturn(coroutine_0, coroutine_0, block);
        break $l$block_0;
      }
      var coroutine_1 = new (DispatchedCoroutine())(newContext, tmp0);
      startCoroutineCancellable(block, coroutine_1, coroutine_1);
      tmp$ret$1 = coroutine_1.ay();
    }
    return tmp$ret$1;
  };
}
var StandaloneCoroutineClass;
function StandaloneCoroutine() {
  if (StandaloneCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(parentContext, active) {
        super(parentContext, true, active);
      }
      px(exception) {
        handleCoroutineException(this.rv_1, exception);
        return true;
      }
    }
    initMetadataForClass($, 'StandaloneCoroutine', VOID, VOID, VOID, [0]);
    StandaloneCoroutineClass = $;
  }
  return StandaloneCoroutineClass;
}
var LazyStandaloneCoroutineClass;
function LazyStandaloneCoroutine() {
  if (LazyStandaloneCoroutineClass === VOID) {
    class $ extends StandaloneCoroutine() {
      constructor(parentContext, block) {
        super(parentContext, false);
        this.hy_1 = createCoroutineUninterceptedGeneratorVersion(block, this, this);
      }
      rw() {
        startCoroutineCancellable_0(this.hy_1, this);
      }
    }
    initMetadataForClass($, 'LazyStandaloneCoroutine', VOID, VOID, VOID, [0]);
    LazyStandaloneCoroutineClass = $;
  }
  return LazyStandaloneCoroutineClass;
}
var DeferredCoroutineClass;
function DeferredCoroutine() {
  if (DeferredCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(parentContext, active) {
        super(parentContext, true, active);
      }
      ly() {
        return this.sx();
      }
      *my($completion) {
        return yield* this.tx($completion);
      }
    }
    initMetadataForClass($, 'DeferredCoroutine', VOID, VOID, [Job()], [0]);
    DeferredCoroutineClass = $;
  }
  return DeferredCoroutineClass;
}
var LazyDeferredCoroutineClass;
function LazyDeferredCoroutine() {
  if (LazyDeferredCoroutineClass === VOID) {
    class $ extends DeferredCoroutine() {
      constructor(parentContext, block) {
        super(parentContext, false);
        this.qy_1 = createCoroutineUninterceptedGeneratorVersion(block, this, this);
      }
      rw() {
        startCoroutineCancellable_0(this.qy_1, this);
      }
    }
    initMetadataForClass($, 'LazyDeferredCoroutine', VOID, VOID, VOID, [0]);
    LazyDeferredCoroutineClass = $;
  }
  return LazyDeferredCoroutineClass;
}
function trySuspend($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.zx_1;
  while (true) {
    switch (this_0.kotlinx$atomicfu$value) {
      case 0:
        if ($this.zx_1.atomicfu$compareAndSet(0, 1))
          return true;
        break;
      case 2:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already suspended';
        throw IllegalStateException().o(toString(message));
    }
  }
}
function tryResume($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.zx_1;
  while (true) {
    switch (this_0.kotlinx$atomicfu$value) {
      case 0:
        if ($this.zx_1.atomicfu$compareAndSet(0, 2))
          return true;
        break;
      case 1:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already resumed';
        throw IllegalStateException().o(toString(message));
    }
  }
}
var DispatchedCoroutineClass;
function DispatchedCoroutine() {
  if (DispatchedCoroutineClass === VOID) {
    class $ extends ScopeCoroutine() {
      constructor(context, uCont) {
        super(context, uCont);
        this.zx_1 = atomic$int$1(0);
      }
      dw(state) {
        this.cw(state);
      }
      cw(state) {
        if (tryResume(this))
          return Unit_instance;
        resumeCancellableWith(intercepted(this.uy_1), recoverResult(state, this.uy_1));
      }
      ay() {
        if (trySuspend(this))
          return get_COROUTINE_SUSPENDED();
        var state = unboxState(this.nw());
        if (state instanceof CompletedExceptionally())
          throw state.yv_1;
        return state;
      }
    }
    initMetadataForClass($, 'DispatchedCoroutine', VOID, VOID, VOID, [0]);
    DispatchedCoroutineClass = $;
  }
  return DispatchedCoroutineClass;
}
//region block: exports
export {
  withContext as withContextp2qc4rbktyej,
  async as asyncz02dsa2nb2zt,
  launch as launch1c91vkjzdi9sd,
};
//endregion

//# sourceMappingURL=Builders.common.mjs.map
